/* eslint-disable no-use-before-define */
import React from 'react'
import { BondInfo } from './bond-info'
import { AdditionalDetails } from './additional-details'
import { RecentTrades } from './recent-trades'
import { useOrderTicket } from '../../use-order-ticket'
import { Loading } from '../../../twd'
import { ChartTable } from '../../../treasury-chart/index.js'
export let Context = () => {

    const { bondInfoStatus, isTreasuryAuction } = useOrderTicket()

    return <React.Fragment>
        <Loading status={bondInfoStatus}>
            <div className="row vertical-offset-sm"></div>
            <BondInfo />
            <div className="row vertical-offset-sm"></div>
            {isTreasuryAuction ? <ChartTable /> : <RecentTrades /> }
            <div className="row vertical-offset-sm"></div>
            <div><AdditionalDetails /></div>
            <div className="row vertical-offset-sm"></div>
        </Loading>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/order-ticket/snapshot/context/context.js